import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Axios from "axios";

//COMPONENTS
import NavBar from "../../mainStyle/components/navBar/navBar";
import HomeSection from "../../mainStyle/components/homeSections/home";
import MeetTheTeam from "../../mainStyle/components/homeSections/meetTheTeam";
import ServicesAndEvents from "../../mainStyle/components/homeSections/servicesAndEvents";
import Community from "../../mainStyle/components/homeSections/community";
import Links from "../../mainStyle/components/homeSections/links";
import ContactUs from "../../mainStyle/components/homeSections/contactUs";

//STYLES
import * as HomeStyles from "../styles/home";

function Home(props) {
    const dispatch = useDispatch();

    const [mouseDirection, setMouseDirection] = useState("null");
    const navBarSettings = useSelector((state) => state.navBar);

    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        if (props.scroll) {
            document.body.style.overflow = "scroll";
        } else {
            document.body.style.overflow = "hidden";
        }
        setLoaded(true);
    }, []);

    return (
        <div id="mainFrame">
            {loaded && (
                <div>
                    <div style={HomeStyles.navBar}>
                        <NavBar />
                    </div>
                    <div style={{ ...HomeStyles.bodies, top: `${navBarSettings.sitePosition}vh` }}>
                        <HomeSection image={navBarSettings.backgroundImages.homeImage} />
                    </div>
                    <div style={{ ...HomeStyles.bodies, top: `${navBarSettings.sitePosition + 100}vh` }}>
                        <MeetTheTeam image={navBarSettings.backgroundImages.meetTheTeamImage} />
                    </div>
                    <div style={{ ...HomeStyles.bodies, top: `${navBarSettings.sitePosition + 200}vh` }}>
                        <ServicesAndEvents image={navBarSettings.backgroundImages.servicesAndEventsImage} />
                    </div>
                    <div style={{ ...HomeStyles.bodies, top: `${navBarSettings.sitePosition + 300}vh` }}>
                        <Community image={navBarSettings.backgroundImages.communityImage} />
                    </div>
                    <div style={{ ...HomeStyles.bodies, top: `${navBarSettings.sitePosition + 400}vh` }}>
                        <Links image={navBarSettings.backgroundImages.linksImage} />
                    </div>
                    <div style={{ ...HomeStyles.bodies, top: `${navBarSettings.sitePosition + 500}vh` }}>
                        <ContactUs image={navBarSettings.backgroundImages.contactUsImage} />
                    </div>
                </div>
            )}
        </div>
    );
}

export default Home;
